import helper from '../helper'

export const serviceTopUpAdmin = {
  get: (token, params) => helper.get('api/v1/transactions-admin', token, params),
  patch: (token, id, params) => helper.patch('api/v1/transactions-admin/' + id + '/confirm', params, token)
}
